/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminSftpSurveyDataService {

    /**
     * List SFTP survey data files and folders for a tenant
     * @returns any Success
     * @throws ApiError
     */
    public static listSftpSurveyData({
        tenantId,
        prefix,
    }: {
        /**
         * Tenant ID (company code)
         */
        tenantId: string,
        /**
         * Sub-path prefix within the tenant's sftp/survey_data directory
         */
        prefix?: string,
    }): CancelablePromise<{
        folders?: Array<{
            name?: string;
            key?: string;
        }>;
        files?: Array<{
            name?: string;
            key?: string;
            size?: number | null;
            lastModified?: string | null;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/sftpSurveyData/{tenantId}',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'prefix': prefix,
            },
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Generate a presigned download URL for an SFTP survey data file
     * @returns any Success
     * @throws ApiError
     */
    public static downloadSftpSurveyData({
        tenantId,
        key,
    }: {
        /**
         * Tenant ID (company code)
         */
        tenantId: string,
        /**
         * Full S3 object key of the file to download
         */
        key: string,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/sftpSurveyData/{tenantId}/download',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'key': key,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Read the processing status of an SFTP survey data file
     * @returns any Success — returns the status object, or null if no status file exists
     * @throws ApiError
     */
    public static readSftpSurveyDataStatus({
        tenantId,
        key,
    }: {
        /**
         * Tenant ID (company code)
         */
        tenantId: string,
        /**
         * Full S3 object key of the status file
         */
        key: string,
    }): CancelablePromise<Record<string, any> | null> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/sftpSurveyData/{tenantId}/status',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'key': key,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
